import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import api from "../../api";
import { PageTitle, TH, TD } from "./AdminLayout";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");

  const load = () => api.get(`/admin/audit${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => setLogs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <div data-testid="admin-audit">
      <PageTitle title="Audit Log" sub="Every administrative action, recorded with actor and target." />
      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative max-w-sm mb-6">
        <Search size={15} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search actor, action, target…" data-testid="audit-search"
          className="w-full bg-white/5 border border-white/10 rounded-full pl-10 pr-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blurple" />
      </form>

      <div className="rounded-lg border border-white/5 bg-panel overflow-x-auto">
        <table className="w-full min-w-[760px]" data-testid="audit-table">
          <thead className="border-b border-white/5"><tr><TH>When</TH><TH>Actor</TH><TH>Action</TH><TH>Target</TH><TH>Change</TH></tr></thead>
          <tbody className="divide-y divide-white/5">
            {logs.map((l) => (
              <tr key={l.id} data-testid={`audit-row-${l.id}`}>
                <TD className="font-mono text-xs text-white/40 whitespace-nowrap">{new Date(l.ts).toLocaleString()}</TD>
                <TD><span className="text-white">{l.actor}</span> <span className="text-white/30 text-xs">({l.actor_role})</span></TD>
                <TD><code className="font-mono text-xs text-volt">{l.action}</code></TD>
                <TD className="text-white/60 text-xs max-w-[200px] truncate">{l.target || "—"}</TD>
                <TD className="text-white/35 text-xs font-mono max-w-[240px] truncate">{l.new ? JSON.stringify(l.new) : "—"}</TD>
              </tr>
            ))}
            {!logs.length && <tr><TD className="text-center py-10 text-white/40" colSpan={5}>No audit entries match.</TD></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
